if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super()

      this.form = this.querySelector('form')
      this.formWrapper = this.form.closest('[data-product-info]')
      this.stickyCheck = this.formWrapper.querySelector('[data-sticky-check]')
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.cartNotification = document.querySelector('cart-notification')
      this.cartDrawer = document.querySelector('cart-drawer')
      this.variantRadios = this.formWrapper.querySelector('variant-radios')

      // See if we have a sticky element to watch
      if (this.formWrapper && this.stickyCheck) {
        // Calculate original height, relative to the document
        this.initialTop = Math.ceil(this.formWrapper.getBoundingClientRect().top)

        document.addEventListener('scroll', () => {
          // Update the setting when we are at the top of the page, this is always the right value
          if (window.scrollY == 0) {
            this.initialTop = this.initialTop = Math.ceil(this.formWrapper.getBoundingClientRect().top)
          }

          var checkTop = this.formWrapper.offsetTop
          this.formWrapper.classList.toggle('is-sticky', checkTop > this.initialTop)
        })
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault()

      // Get the fieldsets from the variant selector and their values
      const fieldsets = Array.from(document.querySelector('variant-radios').querySelectorAll('fieldset'))
      const selectedOptionValues = fieldsets.map((fieldset) => {
        const elem = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
        return elem?.value
      })

      // Guard if all variant options have a value
      if (selectedOptionValues.some((item) => item === undefined)) {
        this.variantRadios.toggleVariantNotice(false, true)
        return
      }

      const submitButton = this.querySelector('[type="submit"]')
      submitButton.setAttribute('disabled', true)
      submitButton.classList.add('loading')
      submitButton.classList.add('button--active')

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const sectionsToFetch = [...this.cartDrawer.getSectionsToRender().map((section) => section.id), ...this.cartNotification.getSectionsToRender().map((section) => section.id)]

      const formData = new FormData(this.form)
      formData.append('sections', sectionsToFetch)
      formData.append('sections_url', window.location.pathname)
      config.body = formData

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement)
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'))
            return
          }

          this.cartDrawer.renderContents(parsedState)
          this.cartDrawer.open()
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          submitButton.classList.remove('loading')
          submitButton.removeAttribute('disabled')
          submitButton.classList.remove('button--active')
        })
    }
  }

  window.ProductForm = ProductForm
  customElements.define('product-form', ProductForm)
}
